// Get the current URL
const environments = {
  devqa: "proxy-qa",
  staging_and_production: "proxy"
  };
const env = window.location.href.indexOf("dev") !== -1 ? environments.devqa : environments.staging_and_production

window.Shopify = window.Shopify || {};
const collectionsUrl = `https://${window.Shopify.shop}${window.Shopify.locale === 'en' ? '' : '/fr'}/collections/`;

// Endpoints
const endpointGetSunglassesCollection = `/apps/${env}/brand-collections/sunglasses`;
const endpointGetEyeglassesCollection = `/apps/${env}/brand-collections/eyeglasses`;

const tabs = document.querySelectorAll(".brand-collection__tab-list-item");

const requestProxy = async (endpoint) => {
  try{
    const response = await fetch(endpoint);
    const result = await response.json();
    return result;
  }catch(error){
    console.error('Error getting collections:', error);
    return false;
  }
}
const displayCollectionByProductType = async (type) => {
  const container = document.querySelector(`.brand-collection__inner [data-collection='${type}']`);
  const containerBrands = container.querySelector(`.brand-collection__brands`);
  const containerBrandsMenu = container.querySelector(`.brand-collection__menu`);

  if(container.classList.contains('--active')){
    showLoader();
  }
  
  const endpointGetCollection = `/apps/${env}/brand-collections/${type}`;
  const responseCollections = await requestProxy(endpointGetCollection);

  const filterType = type.charAt(0).toUpperCase() + type.slice(1);
  const filter = `?sort_by=best-selling&product_type=${filterType}`;
  
  const listsByLetter = {};
  responseCollections.collections.forEach(collection => {
    const firstLetter = collection.title.charAt(0).toUpperCase();
    if (!listsByLetter[firstLetter]) {
      const containerLetter = document.createElement("div");
      containerLetter.classList.add("letter-container");
      containerLetter.dataset.letter = firstLetter;
      containerLetter.innerHTML = `<h2 class="multi-column__grid-item-heading ff-heading fs-heading-4-base">${firstLetter}</h2><ul class="multi-column__grid-item-text ff-body fs-body-100 rte"></ul>`;
      containerBrands.appendChild(containerLetter);
      listsByLetter[firstLetter] = containerLetter.querySelector("ul");
    }
    const listItem = document.createElement("li");
    const link = document.createElement("a");
    link.textContent = collection.title.charAt(0).toUpperCase() + collection.title.slice(1).toLowerCase();
    link.href = `${collectionsUrl}${collection.handle}${filter}`;
    listItem.appendChild(link);
    listsByLetter[firstLetter].appendChild(listItem);
  });
  
  for (const letter in listsByLetter) {
    if (listsByLetter.hasOwnProperty(letter)) {
      const letterLink = document.createElement("a");
      letterLink.dataset.letter = letter;
      letterLink.dataset.collection = type;
      letterLink.textContent = letter;
      containerBrandsMenu.appendChild(letterLink);
    }
  }
  
  containerBrandsMenu.querySelectorAll("a").forEach(brandsMenuLink => {
    brandsMenuLink.addEventListener("click", letterClick);
  });
  if(container.classList.contains('--active')){
    hideLoader();
  }
}
const tabClick = function() {
  const type = this.dataset.tab;
  const contentToActivate = document.querySelector(`.brand-collection__inner [data-collection='${type}']`);
  const tabToActivate = document.querySelector(`.brand-collection__tab-list [data-tab='${type}']`);

  document.querySelectorAll('.brand-collection__content').forEach(content => {
    content.classList.remove('--active');
  });
  contentToActivate.classList.add('--active');

  document.querySelectorAll('.brand-collection__tab-list [data-tab]').forEach(tab => {
    tab.classList.remove('--active');
  });
  tabToActivate.classList.add('--active');
}

const letterClick = function(){
  const type = this.dataset.collection;
  const letter = this.dataset.letter;
  const targetElement = document.querySelector(`.brand-collection__inner [data-collection='${type}'] .letter-container[data-letter='${letter}']`);
  const scrollTopMargin = 50;
  if (targetElement) {
    // Calculate the position to scroll to
    const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - scrollTopMargin;

    // Scroll to the calculated position
    window.scrollTo({
        top: offsetTop,
        behavior: 'smooth' // Optionally smooth scrolling
    });
  }
}

function showLoader() {
  const loader = document.getElementById('loader');
  loader.style.display = 'block';
}

function hideLoader() {
  const loader = document.getElementById('loader');
  loader.style.display = 'none';
}

document.addEventListener("DOMContentLoaded", async () => {
  tabs.forEach(tab => {
    tab.addEventListener("click", tabClick);
  })

  displayCollectionByProductType('eyeglasses');
  displayCollectionByProductType('sunglasses');
  
});